import React from "react";
import { useState, useRef } from "react";
import ExportApi from "../api/ExportApi";
import { toast, ToastContainer } from "react-toastify";
import { MdOutlineKeyboardArrowLeft } from "react-icons/md";

const ForgotPassword = ({
  modal = () => {},
  setSignup = () => {},
  setForgot = () => {}
}) => {
  const [email, setEmail] = useState();
  const [isLoading, setLoading] = useState(false);
  const [isValidEmail, setIsValidEmail] = useState(true);
  const emailInputRef = useRef(null);
  const handleForgotPassword = () => {
    setLoading(true);
    const emailLowercase = email?.toLowerCase().trim();
    if (emailLowercase == "" || emailLowercase == null) {
      toast.error("Please enter an email address");
      setLoading(false);
    } else if (!validateEmail(emailLowercase)) {
      setIsValidEmail(false);
      toast.error("Please Enter Valid Email");
      setLoading(false);
    } else {
      ExportApi.ForgotPassword(emailLowercase)
        .then((resp) => {
          if (resp.data.message == "Email not found") {
            toast.error("Email not found");
            setLoading(false);
          } else {
            setTimeout(() => {
              modal ? modal() : "";
              setLoading(false);
            }, 100);
            toast.success("Forgot password link has been sent Successfully");
          }
        })
        .catch((err) => console.log(err));
    }
  };

  const handleEmail = (e) => {
    const cursorPos = e.target.selectionStart;
    const value = e.target.value.toLowerCase();
    setEmail(value);
    setIsValidEmail(true);
    setTimeout(() => emailInputRef.current?.setSelectionRange(cursorPos, cursorPos), 0);
  };

  const validateEmail = (email) => {
    // Regular expression to validate email format
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleLogin = () => {
    setStap(true);
    setSignup(false);
    setForgot(false);
  };
  return (
    <div>
      <br></br>
      <div className="input-container w-100">
        <label className="label fs-5 mb-2">Email: </label>
        <input
          ref={emailInputRef}
          type="text"
          name="email"
          className="input form-control"
          placeholder="Please Enter Your Email"
          pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$"
          required
          value={email}
          onChange={handleEmail}
        />
      </div>

      <button
        type="submit"
        className=" d-block py-2 text-white mt-4 w-10 mb-3 mx-auto px-4 border-0 resetpwd"
        onClick={handleForgotPassword}
        style={{ backgroundColor: "#990000" }}
        disabled={isLoading ? true : false}
      >
        {isLoading ? "Loading..." : "Reset Password"}
      </button>
      <p className="text-center cursor-pointer" style={{ cursor: "pointer" }} 
      onClick={() => {
        setSignup(false);
        setForgot(false);
      }}>
        <MdOutlineKeyboardArrowLeft className="fs-3" />Back to login</p>
      <ToastContainer />
    </div>
  );
};

export default ForgotPassword;
